import vue from "vue";
import vuex from "vuex";
import api from "../service/api";
vue.use(vuex);
var getUserInfo = window.localStorage;
var emptyUserInfo = {
  isDelete: false,
  createTime: "",
  updateTime: "",
  id: "",
  name: "",
  phoneNumber: "",
  gender:0,
  openId: "",
  subscribe: false,
  shoppingPreference: 0,
  subscribePreference: false
};

var userInfo =
  JSON.parse(getUserInfo.getItem("userInfo")) == null
    ? emptyUserInfo
    : JSON.parse(getUserInfo.getItem("userInfo"));
// console.log(userInfo)
export default new vuex.Store({
  state: {
    API: api,
    otherUrls: [
      "/login",
      "/journal",
      "/journal/archive",
      "/collections/archive/man",
      "/collections/archive/woman",
      "/privacy",
      "/terms",
      "/returns",
      "/shipping",
      "/contact-us",
      "/client-hub",
      "/client-hub/embossing",
      "/client-hub/madetomeasure",
      "/client-hub/gifting",
      "/client-hub/tailoring"
    ],
    titleSuffix: " | THOM BROWNE 中国官方网站",
    ossSuffix: "?x-oss-process=style/tb",
    ossSuffixOriginSuff:"_origin",
    partName: "",
    showPart: true,
    name: userInfo.name,
    userId: userInfo.id,
    openId: userInfo.openId,
    gzhOpenId: "",
    //prod
    tempCover:'https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202206/2308ab9daad61eb26909e67ab53703e7.jpeg',
    appid:
      process.env.ENV_CONFIG == "prod" || process.env.ENV_CONFIG == "staging"
        ? "wxdb3533ad97ef115d"
        : "wxb8b84b3c88563e6f", //wxdb3533ad97ef115d prod   //wxb8b84b3c88563e6f uat
    entityId:
      process.env.ENV_CONFIG == "prod" || process.env.ENV_CONFIG == "staging"
        ? "51b5dc43-977c-4711-ad3a-fd475e22955c"
        : "54600421-438a-46e0-90db-4094e241d6ba", //51b5dc43-977c-4711-ad3a-fd475e22955c // prod     9d1a363e-5350-4123-a8a7-90da23ce2f53 //uat
    storeId:
      process.env.ENV_CONFIG == "prod" || process.env.ENV_CONFIG == "staging"
        ? "5f6d97f2-b266-47cb-af56-72855f4c93bf"
        : "54600421-438a-46e0-90db-4094e241d6ba", //5f6d97f2-b266-47cb-af56-72855f4c93bf  prod    //54600421-438a-46e0-90db-4094e241d6ba  uat
    collectionId:  process.env.ENV_CONFIG == "prod" || process.env.ENV_CONFIG == "staging" ?'5126ac99-b8f1-4353-b94e-22637841ef69':'011b5c7f-ed2a-4e1f-b149-425cbcc69db0',
    access_token: getUserInfo.getItem("token"),
    countingDown: getUserInfo.getItem("countingDown"),
    countingDown2: getUserInfo.getItem("countingDown2"),
    shopCartFalg: false,
    RefreshShopCart: false,
    RefreshAcountNav: false,
    phoneNumber: userInfo.phoneNumber,
    subscribe: userInfo.subscribe,
    shoppingPreference: userInfo.shoppingPreference,
    subscribePreference: userInfo.subscribePreference,
    shoppingPreferenceTypes: userInfo.shoppingPreferenceTypes,
    showLoginPop: false,
    loveListFalg: false,
    RefreshLoveList: false,
    cartCount: 0,
    lovecount: 0,
    isExitlogin: false, //是否操作了退出登录
    isClickAcount: false, //是否点击了accout菜单
    gender: 0,
    addressInfo: null,
    showRefound: false,
    isActivityPage:false,
    showSubPop: false,
    showOrderDetail: false,
    pageTitle: "",
    isSupportWebp: false,
    showWeChatPop: false,
    welcomeLogin: false, //是否显示欢迎登录pop
    welcomeEmailFlag: false, // 是否进行邮箱登录的标记
    soldOut: 0, //0 隐藏 1 显示
    hasChangUrl: false,
    loginOverTo: "/",
    getShowAdd: false,
    crmMember: false,
    userLogin: false,
    footerList: [],
    screenWidth: null,
    seoTitle:"",
    metaInfo: {},
    scrollTop: 0,
    productCare:{}
  },
  getters: {
    getPartName: (state, getters) => {
      return state.partName;
    }
  },
  mutations: {
    resetUserInfo(state, payload) {
      state.name = payload.name;
      state.userId = payload.id;
      state.openId = payload.openId;
      state.phoneNumber = payload.phoneNumber;
      //state.subscribe = payload.subscribe;
      state.shoppingPreference = payload.shoppingPreference;
      state.subscribePreference = payload.subscribePreference;
      state.shoppingPreferenceTypes = payload.shoppingPreferenceTypes;
      state.gender = payload.gender;
    },
    setisActivityPage(state, value){
      state.isActivityPage=value
    },
    setValue(state, value) {
      vue.set(state, value[0], value[1]);
    },

    updateState(state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key];
      });
    },
    setPartName(state, payload) {
      state.partName = payload;
    },
    setShowPart(state, payload) {
      state.showPart = payload;
    },
    showShopCartPop(state, payload) {
      state.shopCartFalg = payload;
    },
    RefreshShopCart(state, payload) {
      state.RefreshShopCart = payload;
    },
    RefreshAcountNav(state, payload) {
      state.RefreshAcountNav = payload;
    },
    UpdateLoginStatus(state, payload) {
      state.isExitlogin = payload;
    },
    upDateShopCount(state, payload) {
      state.cartCount = payload;
    },
    upDateLoveCount(state, payload) {
      state.lovecount = payload;
    },
    RefreshLoveList(state, payload) {
      state.RefreshLoveList = payload;
    },
    showLoveListPop(state, payload) {
      state.loveListFalg = payload;
    },
    RefreshAcountMeau(state, payload) {
      state.isClickAcount = payload;
    },
    CAHNGE_META_INFO(state, metaInfo) { 
      state.metaInfo = metaInfo;
  }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js